/**
 * Colorblind-safe chart constants.
 *
 * Palette sourced from Wong 2011 (Nature Methods 8, 441) -- widely adopted
 * as the gold standard for data visualisation accessibility.  Each hue is
 * distinguishable across all three major types of colour-vision deficiency
 * (protanopia, deuteranopia, tritanopia).
 *
 * Stroke dash arrays provide a secondary visual channel so series can be
 * differentiated without relying on colour alone (WCAG 1.4.1).
 */

/** Wong 2011 colorblind-safe palette */
export const CB_PALETTE = {
  blue: '#0072B2',
  orange: '#E69F00',
  green: '#009E73',
  vermillion: '#D55E00',
  purple: '#CC79A7',
} as const;

/** Stroke dash patterns for line differentiation */
export const STROKE_DASH = {
  solid: '0',
  dashed: '8 4',
  dotted: '2 4',
} as const;

/**
 * Indexable cycling order for multi-series charts (F3 trend mode): color and
 * dash pattern cycle INDEPENDENTLY — `CB_PALETTE_ORDER[i % 5]` +
 * `STROKE_DASH_ORDER[Math.floor(i / 5) % 3]` — so series 1 and series 6 never
 * render pixel-identical (the WCAG 1.4.1 point of this file). Named exports
 * above stay untouched for existing single-key call sites.
 */
export const CB_PALETTE_ORDER = [
  CB_PALETTE.blue,
  CB_PALETTE.orange,
  CB_PALETTE.green,
  CB_PALETTE.vermillion,
  CB_PALETTE.purple,
] as const;

export const STROKE_DASH_ORDER = [
  STROKE_DASH.solid,
  STROKE_DASH.dashed,
  STROKE_DASH.dotted,
] as const;
